import React, { FunctionComponent } from "react";

const AngleBracketsIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/interface-essential/text-formating/angle-brackets
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m7.629 4.5-6.44 6.439a1.5 1.5 0 0 0 0 2.121l6.44 6.44"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="m16.371 4.5 6.44 6.439a1.5 1.5 0 0 1 0 2.121l-6.44 6.44"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default AngleBracketsIcon;
